import Vue from 'vue'
import Router from 'vue-router'

import { i18n } from '@/i18n'
import store from '@/store/store'

import LangPart from '@/components/LangPart'

import Home from '@/components/views/home'
import Productos from '@/components/views/productos'
import Product_details from '@/components/views/product-details'
import ProductosQuimicos from '@/components/views/productos-quimicos'
import Catalogo from '@/components/views/catalogo'
import Area_tecnica from '@/components/views/area-tecnica'
import Ajusa from '@/components/views/ajusa'
import HistoriaInfografia from '@/components/views/historia-infografia'

import Actualidad from '@/components/views/actualidad'
import Blog from '@/components/views/blog'
import Categoria_blog from '@/components/views/categoria-blog'
import Ficha_blog from '@/components/views/ficha-blog'
import SalaPrensa from '@/components/views/sala-prensa'

import Contacto from '@/components/views/contacto'
import TrabajaConNosotros from '@/components/views/trabaja-con-nosotros'

import PoliticaPrivacidad from '@/components/views/politica-privacidad'
import PoliticaCookies from '@/components/views/politica-cookies'
import DatosSeguros from '@/components/views/datos-seguros'
import AvisoLegal from '@/components/views/aviso-legal'
import VehiculoElectrico from '@/components/views/vehiculo-electrico'
import MapaWeb from '@/components/views/mapa-web'
import bonosAjusa from '@/components/views/bonos-ajusa';
import thankYouPage from '@/components/views/thank-you-page';

import messages from '@/translations';

Vue.use(Router);
let routes = [
    {
        path: '/:lang(es|en|ru|br|fr|us)?',
        name: "language-part",
        component: LangPart,
        children: [
            //STATIC
            {
                alias: `/home`,
                name: 'home',
                component: Home,
            },
            {
                name: 'sobre_nosotros',
                component: Ajusa,
            },
            {
                name: 'aniversario50',
                component: HistoriaInfografia
            },
            {
                name: 'mapa_web',
                component: MapaWeb,
            },
            {
                name: 'politica',
                component: PoliticaPrivacidad,
            },
            {
                name: 'politica_cookies',
                component: PoliticaCookies,
            },
            {
                name: 'aviso_legal',
                component: AvisoLegal,
            },
            {
                name: 'datos_seguros',
                component: DatosSeguros,
            },
            {
                name: 'vehiculo_electrico',
                component: VehiculoElectrico,
            },
            {
                name: 'area_tecnica',
                component: Area_tecnica,
                meta: {
                    idParameter: true,
                }
            },
            //PRODUCTS
            {
                name: 'productos',
                component: Productos,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'product',
                component: Product_details,
                meta: {
                    idParameter: true
                }
            },
            {
                name: 'productos_quimicos',
                component: ProductosQuimicos,
            },
            //CATALOG
            {
                name: 'catalogo',
                component: Catalogo,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'actualidad',
                component: Actualidad,
            },
            {
                name: 'blog',
                component: Blog,
            },
            {
                name: 'blog_noticia',
                component: Ficha_blog,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'blog_categoria',
                component: Categoria_blog,
                meta: {
                    idParameter: true,
                }

            },
            //FORMS
            {
                name: 'contacto',
                component: Contacto,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'sala_prensa',
                component: SalaPrensa,
            },
            {
                name: 'trabaja_con_nosotros',
                component: TrabajaConNosotros,
                meta: {
                    idParameter: true,
                }
            },
            {
                name: 'bonos_ajusa',
                component: bonosAjusa,
                idParameter: true,
            },
            //THANK YOU PAGE
            {
                name: 'newsletter_thank',
                component: thankYouPage,
            },
        ]
    }
];

routes[0].children.forEach(function (value, key) {
    if (value.path == null) {
        value.path = i18n.t('enlaces.' + value.name);
        value.alias = [];
        value.meta = value.meta ? value.meta : {};
        value.meta.seo = value.meta.seo ? value.meta.seo : {};
        Object.keys(messages).forEach(function (lang) {
            if (value.meta.seo[lang] == null) {
                value.meta.seo[lang] = messages[lang].enlaces.seo[value.name];
            }
            if (
                messages[lang].enlaces[value.name] != null &&
                messages[lang].enlaces[value.name] != value.path &&
                value.alias.includes(messages[lang].enlaces[value.name]) == false
            ) {
                value.alias.push(messages[lang].enlaces[value.name]);
            }

        });
        if (value.meta.idParameter) {
            value.path += "/:id?";
            value.alias.forEach(function (alia, index) {
                value.alias[index] += "/:id?";
            });
        }
    }
});

const router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
});

router.beforeEach((to, from, next) => {
    to.meta.previousRoute = from.name;
    if (to.params.lang == null) {
        to.params.lang = store.getters.getLanguage ? store.getters.getLanguage : i18n.locale;
        next({
            path: to.params.lang + "/" + i18n.t('enlaces.' + to.name),
            name: to.name ? to.name : "home",
            params: to.params,
        });
        return;
    }
    if (to.params.lang && to.params.lang != store.getters.getLanguage) {
        let lang = to.params.lang;
        store.dispatch('changeLanguage', lang);
    }

    let explode = to.path.split("/");

    if (to.name && to.name != "home" && explode.length > 2) {
        explode.shift();
        explode.shift();
        if (to.meta.idParameter && to.params.id) {
            explode.pop();
        }
        explode = explode.join("/");
        if (explode != i18n.t('enlaces.' + to.name)) {
            //Yeah...risky as hell
            let url = "/" + to.params.lang + "/" + i18n.t('enlaces.' + to.name);
            if (to.params.id) {
                url += "/" + to.params.id;
            }
            next(url);
            return;
        }
    }

    let meta = (to.meta.seo) ? to.meta.seo[to.params.lang] : null;
    
    const origin = window.location.origin; 
    document.head.querySelector("[rel='canonical']").href = origin + to.fullPath;

    if (!!meta && !!meta.description) {
        document.title = meta.title
        document.head.querySelector("[property='og:title']").content = meta.title;
        document.head.querySelector("[name=description]").content = meta.description;
        document.head.querySelector("[property='og:description']").content = meta.description;
        document.head.querySelector("[property='og:url']").content = location.href; 
       
            switch (to.name) {
                case 'home':
                    document.head.querySelector("[name=keywords]").content = meta.keyword;
                    break;
                case 'productos':
                    document.head.querySelector("[name=keywords]").content = meta.keyword;
                    break;
                case 'vehiculo_electrico':
                    document.head.querySelector("[name=keywords]").content = meta.keyword;
                    break;
                default:
                    document.head.querySelector("[name=keywords]").content = '';
                    break;
            }
        
    }
    next()
});


export default router;


// WEBPACK FOOTER //
// ./src/router/index.js